import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProjectService } from 'src/app/shared/project/project.service';

@Component({
  selector: 'changes-modal',
  templateUrl: 'changes-modal.component.html',
  styleUrls: ['../general.scss']
})
export class ChangesModalComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private projectService: ProjectService) {
        console.log('injected data:');
        console.log(data);
    }
}
